export default [
    {
        path: "/admin/cash-requests",
        name: "cash-request",
        meta: { requiresAuth: true },
        component: () =>
            import("@/pages/finance/cash-request/index.vue")
    },
    {
        path: "/admin/cash-requests/create",
        name: "cash-request-create",
        meta: { requiresAuth: true },
        component: () =>
            import("@/pages/finance/cash-request/create.vue")
    },
    {
        path: "/admin/cash-requests/:id/edit",
        name: "cash-request-edit",
        meta: { requiresAuth: true },
        component: () =>
            import("@/pages/finance/cash-request/edit.vue")
    }
];
